import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAuth,
  sendEmailVerification,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import I18n from "i18n-js";
import { parentsFirebase } from "app/Auth";
import Constants from "common/constant";
import { usePlaySound } from "common/utils";
import { Footer } from "features/home";
import { useSignUp } from "./hook";
import { BackBtn } from "./BackBtn";
import { MobileInput } from "./AuthStyles";

export const EmailRegisterScreen = () => {
  useSignUp();
  const navigate = useNavigate();
  const playSound = usePlaySound();
  const auth = getAuth(parentsFirebase);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleRegister = async () => {
    playSound();
    if (!password || !confirmPassword) {
      setError(I18n.t("MSG_SIGN_PASSWORD_REQUIRED"));
      return;
    }

    if (password !== confirmPassword) {
      setError(I18n.t("MSG_SIGN_PASSWORD_MISMATCH"));
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const actionCodeSettings = {
        url: import.meta.env.VITE_PUBLIC_URL,
        handleCodeInApp: false,
      };
      createUserWithEmailAndPassword(auth, email, password)
        .then(() => {
          sendEmailVerification(auth.currentUser, actionCodeSettings);
          navigate("/");
        })
        .catch((error) => {
          console.error(error);
          if (error.code === "auth/email-already-in-use") {
            setError(I18n.t("MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"));
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {
      console.error(err);
      setError(I18n.t("MSG_SIGN_UP_FAILED"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex-col-el flex-center relative w-full h-full">
      <img
        alt="*"
        src={`${Constants.assetHost}/assets/images/new_bg_puzzle.png`}
        className="absolute inset-0 object-cover w-full h-full z-[-1]"
      />
      <BackBtn />
      <div className="flex-col-el flex-center w-full h-full max-w-md mx-auto">
        <div className="flex-col-el flex-center w-full">
          <div className="flex-col-el flex-center">
            <p className="text-body text-3xl !mb-6 text-center text-textcolor-black">
              {I18n.t("MSG_SIGN_UP_WITH_MAIL")}
            </p>
          </div>

          <div className="flex-col-el flex-center w-full max-w-sm gap-4">
            <MobileInput
              type="email"
              value={email}
              onChange={(e) => {
                setError("");
                setEmail(e.target.value);
              }}
              placeholder={I18n.t("MSG_SIGN_USER_MAIL")}
              label={I18n.t("MSG_SIGN_USER_MAIL")}
              disabled={isLoading}
              className={error && !email ? "!border-red-500 !bg-red-50" : ""}
            />

            <MobileInput
              type="password"
              value={password}
              onChange={(e) => {
                setError("");
                setPassword(e.target.value);
              }}
              placeholder={I18n.t("MSG_SIGN_USER_PASSWORD")}
              label={I18n.t("MSG_SIGN_USER_PASSWORD")}
              disabled={isLoading}
              className={error && !password ? "!border-red-500 !bg-red-50" : ""}
            />

            <MobileInput
              type="password"
              value={confirmPassword}
              onChange={(e) => {
                setError("");
                setConfirmPassword(e.target.value);
              }}
              placeholder={I18n.t("MSG_SIGN_USER_PASSWORD_CONFIRM")}
              label={I18n.t("MSG_SIGN_USER_PASSWORD_CONFIRM")}
              disabled={isLoading}
              className={
                error && !confirmPassword ? "!border-red-500 !bg-red-50" : ""
              }
            />

            {error && (
              <p className="text-body text-sm text-red-500 text-center">
                {error}
              </p>
            )}

            <div className="flex-col-el flex-center w-full max-w-sm gap-4 upsilon">
              <button
                className="btn btn-primary w-[375px] h-[40px]"
                onClick={handleRegister}
              >
                <p className="text-body text-base">
                  {I18n.t("MSG_SIGN_UP_BTN")}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
